import { render, staticRenderFns } from "./dynamic-post.vue?vue&type=template&id=28b326f5&scoped=true&"
import script from "./dynamic-post.vue?vue&type=script&lang=js&"
export * from "./dynamic-post.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-post.vue?vue&type=style&index=0&id=28b326f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b326f5",
  null
  
)

export default component.exports